import { ref, onMounted, computed, readonly } from "vue";
import { useStore } from "vuex";

export function useInstitutionOptions() {
  const store = useStore();
  const loading = ref(false);

  const fetchData = async () => {
    if (store.getters["institutions/getAllOptions"].length > 0) {
      return; // Data already loaded
    }

    loading.value = true;

    try {
      await store.dispatch("institutions/getAllOptions");
    } finally {
      loading.value = false;
    }
  };

  onMounted(fetchData);

  return {
    institutions: computed(() => store.getters["institutions/getAllOptions"]),
    loading: readonly(loading),
    refetch: fetchData,
  };
}
